import { CheckCircle2 } from 'lucide-react';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContentDocument } from '../types';

export function SMBWhyTrustNerdWalletBullet({
  props,
}: NodeProps<{ children: StructuredContentDocument }>) {
  return (
    <div className="flex [&_div]:!mb-0">
      <CheckCircle2 aria-hidden className="mr-0.5 size-5 shrink-0 text-primary" />
      <StructuredContentRenderer doc={props.children} />
    </div>
  );
}
